import { useLocation } from 'react-router-dom';

import { type Locale } from './config';
import { resolveClientLocale } from './browser';
import { getLocaleFromPathname } from './path';

export function useLocale(): Locale {
  const location = useLocation();
  const pathname = location?.pathname ?? '/';
  return getLocaleFromPathname(pathname) ?? resolveClientLocale();
}
